import { ModalCustom } from "components/ModalCustom";
import { DropdownSelect } from "components/DropdownSelect";
import { PrimaryButton } from "components/Button/style";
import { FaExclamation } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { MOTIVOS_CORRECAO } from "../../constants/motivosCorrecao";
import {
  CaixaCampos,
  CampoContainer,
  Contador,
  FooterBotoes,
  IconeCirculo,
  TextoDescricao,
  TituloComIcone,
} from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: (motivo: string, descricao: string) => void;
}

const LIMITE_DESCRICAO = 1500;

export function ModalSolicitarCorrecao({ show, handleClose, onConfirm }: IProps) {
  const [motivo, setMotivo] = useState<string | null>(null);
  const [descricao, setDescricao] = useState("");

  useEffect(() => {
    if (!show) {
      setMotivo(null);
      setDescricao("");
    }
  }, [show]);

  const handleConfirm = () => {
    if (!motivo) return;
    const labelMotivo = MOTIVOS_CORRECAO.find((m) => m.value === motivo)?.label ?? motivo;
    onConfirm(labelMotivo, descricao);
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={
        <TituloComIcone>
          <IconeCirculo>
            <FaExclamation />
          </IconeCirculo>
          Solicitar correção de lote
        </TituloComIcone>
      }
      centered
      footer
      footerTools={
        <FooterBotoes>
          <PrimaryButton outline variante="primary" onClick={handleClose}>
            Cancelar
          </PrimaryButton>
          <PrimaryButton onClick={handleConfirm} disabled={!motivo}>
            Salvar
          </PrimaryButton>
        </FooterBotoes>
      }
    >
      <TextoDescricao>Selecione abaixo o motivo para correção do lote.</TextoDescricao>
      <CaixaCampos>
        <CampoContainer>
          <Form.Group>
            <Form.Label>
              Motivo <span style={{ color: "#ee5353" }}>*</span>
            </Form.Label>
            <DropdownSelect
              options={MOTIVOS_CORRECAO}
              title=""
              selectedValue={motivo}
              onSelect={setMotivo}
              required
            />
          </Form.Group>
        </CampoContainer>
        {motivo && (
          <CampoContainer>
            <Form.Group>
              <Form.Label>Informe o motivo</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                maxLength={LIMITE_DESCRICAO}
                placeholder="Informe o motivo da solicitação de correção do lote"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
              />
              <Contador>
                {descricao.length}/{LIMITE_DESCRICAO}
              </Contador>
            </Form.Group>
          </CampoContainer>
        )}
      </CaixaCampos>
    </ModalCustom>
  );
}
